module.exports = {
      id: "youtube-usage",
      viewBox: "0 0 15 10",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#youtube",
      toString: function () {
        return this.url;
      }
    }